import React, { PropsWithChildren } from 'react';
import { Pill } from './Pill';

export type HorizontalDividerProps = PropsWithChildren<{
  width?: React.CSSProperties['width'];
  color?: string;
  height?: number;
  thickness?: number;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}>;

export const HorizontalDivider: React.FC<HorizontalDividerProps> = ({
  width = 'auto',
  height = '18px',
  thickness = 3,
  color = 'var(--bs-table-border-color)',
  onClick,
  children,
  style = {},
  className = '',
}) => {
  return (
    <div
      role="button"
      style={{
        ...style,
        position: 'relative',
        height: thickness,
        border: 0,
        padding: 0,
        backgroundColor: color,
      }}
      onClick={onClick}
      className={`w-100 d-flex justify-content-center show-on-hover ${className}`}
    >
      <Pill
        style={{
          position: 'absolute',
          top: `calc(-${height} / 2 + ${thickness}px / 2)`,
          overflow: 'visible',
          padding: 1,
          backgroundColor: 'inherit',
        }}
        height={height}
        width={width}
        className="d-flex justify-content-center align-items-center"
      >
        {children}
      </Pill>
    </div>
  );
};
